/* globals dataLayer, angular */
(function(window, angular, undefined) {
    angular.module('formApp')
        .component('freeCoverRecognition', {
            templateUrl: 'components/free-cover-recognition/templates/free-cover-recognition.html',
            bindings: {
                formData: '<',
                pah: '<'
            },
            controller: ['FormService', 'LoadingInterceptor', '$http', 'API_URL', 'dataUtils', 'errorHandler', '$filter', '$scope', 'scrollToPoint', '$timeout', function(formService, loadingInterceptor, $http, apiUrl, dataUtils, errorHandler, $filter, $scope, scrollToPoint, $timeout) {
                var ctrl = this;
                var uri;
                var postCover;
                ctrl.showMatch = false;
                ctrl.petName = '';
                ctrl.isVoucher = false;

                var oldLastName;
                var oldHouse;
                var oldPostCode;

                var timer;

                var requests = [];


                function clearRequest(request) {
                    requests.splice(requests.indexOf(request), 1);
                }
                
                function cancel() {
                    if (requests) {
                        angular.forEach(requests, function(request) {
                            request.cancel();
                            clearRequest(request);
                        });
                    }
                }


                function getMatch(data) {
                    cancel();
                    var matchPromise = formService.getMatchingCovernote(data);
                    requests.push(matchPromise);
                    matchPromise.then(function(response) {
                        uri = response.data.matchData[0].uri;
                        ctrl.petName = response.data.matchData[0].petName;
                        ctrl.showMatch = true;
                        ctrl.isVoucher = response.data.matchData[0].voucher && response.data.matchData[0].voucher === 'true';
                        ctrl.coverStartDate = response.data.matchData[0].coverExtensionStartDate;
                        ctrl.coverStartDateMin = moment().format('YYYY-MM-DD');
                        ctrl.coverStartDateMax = moment(response.data.matchData[0].coverEndDate).add(1,'day').format('YYYY-MM-DD');
                        ctrl.activateByDate = moment(response.data.matchData[0].coverEndDate, 'YYYY-MM-DD').add(1,'day').toDate();
                        ctrl.daysRemaining = moment(response.data.matchData[0].coverEndDate, 'YYYY-MM-DD').startOf('day').diff(moment().startOf('day'), 'days');
                        ctrl.illnessStartDate = moment(response.data.matchData[0].parisIllnessStartDate, 'YYYY-MM-DD').toDate();
                        
                        ctrl.channel = dataUtils.freeCoverChannel(response.data.matchData[0].prodId);

                        var capitalize = $filter('capitalize');
                        ctrl.customerName = capitalize((ctrl.formData.aboutYou.firstName + ' ' + ctrl.formData.aboutYou.lastName).toLowerCase());

                        dataLayer.push({
                            'event': 'sfcPopup'
                        });

                        $timeout(function () {
                            scrollToPoint.scrollTo('SFCModal', 20, 'id');
                        });

                    }).catch(function() {
                        $scope.$emit('recognitionCancelled');
                    });
                }


                ctrl.$doCheck = function () {
                    if (ctrl.formData.aboutYou.firstName && ctrl.formData.aboutYou.lastName && ctrl.formData.aboutYou.dateOfBirth && ctrl.formData.aboutYou.contactNumber && ctrl.formData.aboutYou.email && ctrl.formData.aboutYou.houseNameOrNumber && ctrl.formData.aboutYou.postCode) {
                        if (!angular.equals([oldLastName, oldHouse, oldPostCode], [ctrl.formData.aboutYou.lastName, ctrl.formData.aboutYou.houseNameOrNumber, ctrl.formData.aboutYou.postCode])) {
                            oldLastName = angular.copy(ctrl.formData.aboutYou.lastName);
                            oldHouse = angular.copy(ctrl.formData.aboutYou.houseNameOrNumber);
                            oldPostCode = angular.copy(ctrl.formData.aboutYou.postCode);
                            clearTimeout(timer);
                            timer = setTimeout(function() { 
                                console.log("check for match"); 
                                getMatch({
                                    "customer": {
                                        "lastName": oldLastName,
                                        "houseNameOrNumber": oldHouse,
                                        "postCode": oldPostCode
                                    }
                                });
                            }, 1000);
                            
                        } 
                    }
                };


                ctrl.cancel = function() {
                    formService.postRecognisedCovernote(uri, false, {}).then(function() {
                        ctrl.showMatch = false;
                        $scope.$emit('recognitionCancelled');
                        dataLayerPush(true);
                    }).catch(function(error) {
                        errorHandler.reportErrors(error,'redirect','tech');
                    });
                };

                ctrl.continue = function() {

                    var data = {
                        contactNumber: ctrl.formData.aboutYou.contactNumber,
                        email: ctrl.formData.aboutYou.email,
                        quoteFollowupMarketingOptOut: ctrl.formData.aboutYou.quoteFollowupMarketingOptOut,
                        dateOfBirth: ctrl.formData.aboutYou.dateOfBirth
                    };

                    // post to update details
                    loadingInterceptor.incrementRequests();
                    formService.postRecognisedCovernote(uri, true, data).then(function() {
                        // update cover start date for new application
                        postCover = apiUrl + '/sa/cn/insuranceForm/' + uri + '/application/cover';
                        return $http.post(postCover, {startDate: ctrl.coverStartDate});
                    }).then(function() {
                        loadingInterceptor.incrementRequests();
                        sessionStorage.setItem('eCoverNote', true);
                        // then...
                        sessionStorage.setItem('formStateUri', uri);
                        sessionStorage.setItem('currentRefreshState', 'quote-ec');
                        sessionStorage.setItem('eCoverJourney', 'recognised');

                        sessionStorage.removeItem('campaign');

                        document.cookie = "campaign=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";

                        dataLayerPush();

                        var env = window.location.hostname;
                        if (env.search('petplan.co.uk') !== -1) {
                            window.location.href='/ecover/quote';  
                        }
                        else {
                            window.location.href='/content/ah_small-animal/ecover/index.html/ecover/quote';
                        }

                    }).catch(function(error) {
                        errorHandler.reportErrors(error,'redirect','tech');
                    });

                };

                ctrl.showDeferment = function() {
                    return ctrl.isVoucher && moment(ctrl.coverStartDate, 'YYYY-MM-DD').isBefore(moment(ctrl.illnessStartDate));
                };
                
                if (sessionStorage.getItem('formStateUri')) {
                    // init form service
                    formService.setApplicationId(sessionStorage.getItem('formStateUri'));
                }   

                function dataLayerPush(newQuote) {
                    dataLayer.push({
                        'event': 'sfcFormComplete',
                        'policyStart': ctrl.coverStartDate,
                        'submitType': newQuote ? 'ctdNewQuote' : 'ctdQuote'
                    });
                }
                
            }]  
        });
})(window, window.angular);